export default __webpack_public_path__ + "static/scic-videoMiseEnAvant-50ebb963e20eabd4a4f8454e9fee9e0d.mp4";